var render = function render(){
  var _vm$form$errors$get, _vm$request, _vm$request2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "heading, table-row@3, button"
    }
  })], 1)], 1) : _vm._e(), !_vm.loading ? _c('v-card', [_c('v-card-text', [_c('form', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "9"
    }
  }, [_vm.request !== null ? _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "value": _vm.form.id,
      "disabled": "disabled",
      "label": "ID"
    }
  })], 1), _vm.$helper.permission.canSeeScore(_vm.user) ? _c('v-col', {
    staticClass: "pt-3",
    attrs: {
      "sm": "auto"
    }
  }, [_c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm._v("Скоринг")]), _vm.request.scoringEnabled === false ? _c('v-chip', {
    attrs: {
      "outlined": "",
      "color": "grey",
      "title": "Скоринг для подразделения отключен"
    }
  }, [_vm._v("отключен")]) : _vm.score !== null && _vm.score !== undefined ? _c('v-chip', {
    attrs: {
      "dark": "",
      "color": _vm.$helper.aiScoreColor(_vm.score.score)
    },
    on: {
      "click": function ($event) {
        _vm.dialog.scoreDetail.modal = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.score.score) + " ")]) : _vm.request.scorePending ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "18",
      "width": "2",
      "color": "grey",
      "title": "Скоринг ещё считается"
    }
  }) : _c('v-icon', {
    attrs: {
      "small": "",
      "color": "grey",
      "title": "Пока не понятно, о чём заявка — не было ещё первого контакта, ждём"
    }
  }, [_vm._v("mdi-account-question-outline")])], 1) : _vm._e(), _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "items": _vm.states,
      "disabled": !_vm.isManualDrivenState(_vm.form.state) && !_vm.$helper.permission.canChangeNotManualState(_vm.user, _vm.form.state),
      "label": "Статус"
    },
    on: {
      "change": _vm.onChangeState
    },
    model: {
      value: _vm.form.state,
      callback: function ($$v) {
        _vm.$set(_vm.form, "state", $$v);
      },
      expression: "form.state"
    }
  }), _vm.form.errors.has('state') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('state')) + " ")]) : _vm._e(), _vm.isFailureState(_vm.form.state) ? _c('div', [_c('v-autocomplete', {
    attrs: {
      "items": _vm.failureReasons,
      "return-object": "",
      "label": "Причина",
      "clearable": true
    },
    model: {
      value: _vm.form.failureReason,
      callback: function ($$v) {
        _vm.$set(_vm.form, "failureReason", $$v);
      },
      expression: "form.failureReason"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Комментарий к причине"
    },
    model: {
      value: _vm.form.failureComment,
      callback: function ($$v) {
        _vm.$set(_vm.form, "failureComment", $$v);
      },
      expression: "form.failureComment"
    }
  })], 1) : _vm._e(), _vm.request.appointmentDate ? _c('div', [_c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "value": _vm.request.appointmentDate,
      "disabled": ""
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "value": _vm.request.appointmentTime.text,
      "disabled": ""
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "sm": "auto"
    }
  }, [_vm.$helper.permission.canMakeAppointments(_vm.user) ? _c('AppointmentDialog', {
    attrs: {
      "id": _vm.form.id,
      "request": _vm.request,
      "isNewAppointment": !_vm.request.appointmentDate,
      "offices": _vm.page.offices
    },
    on: {
      "saved": _vm.onAppointmentAdd
    }
  }) : _vm._e()], 1), _vm.request.appointmentDate && _vm.request.state !== 'CANCEL_ZAPIS' ? _c('v-col', {
    attrs: {
      "sm": "auto"
    }
  }, [_vm.$helper.permission.canMakeAppointments(_vm.user) ? _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "400"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "outlined": "",
            "color": "red"
          }
        }, on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-cancel")]), _vm._v(" Отменить запись ")], 1)];
      }
    }], null, false, 2203474934),
    model: {
      value: _vm.dialog.cancelAppointment.modal,
      callback: function ($$v) {
        _vm.$set(_vm.dialog.cancelAppointment, "modal", $$v);
      },
      expression: "dialog.cancelAppointment.modal"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("Отменить запись")]), _c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "items": _vm.failureReasons,
      "return-object": "",
      "label": "Причина",
      "clearable": true
    },
    model: {
      value: _vm.dialog.cancelAppointment.failureReason,
      callback: function ($$v) {
        _vm.$set(_vm.dialog.cancelAppointment, "failureReason", $$v);
      },
      expression: "dialog.cancelAppointment.failureReason"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Комментарий к причине"
    },
    model: {
      value: _vm.dialog.cancelAppointment.failureComment,
      callback: function ($$v) {
        _vm.$set(_vm.dialog.cancelAppointment, "failureComment", $$v);
      },
      expression: "dialog.cancelAppointment.failureComment"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.dialog.cancelAppointment.modal = false;
      }
    }
  }, [_vm._v("Закрыть")]), _c('v-btn', {
    attrs: {
      "color": "red",
      "text": "",
      "disabled": !_vm.dialog.cancelAppointment.failureReason
    },
    on: {
      "click": _vm.cancelAppointment
    }
  }, [_vm._v(" Отменить запись ")])], 1)], 1)], 1)], 1) : _vm._e(), !_vm.request.appointmentApproved ? _c('div', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "green"
    },
    on: {
      "click": _vm.approveAppointment
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v(" Подтвердить запись ")], 1)], 1) : _vm._e(), _vm.request.appointmentApproved ? _c('div', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "green"
    },
    on: {
      "click": _vm.cancelApproveAppointment
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v(" Запись подтверждена ")], 1)], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _c('v-row', [_vm.$helper.permission.canSeeSourceOfRequest(_vm.user) || !_vm.request ? _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "items": _vm.sources,
      "item-value": "id",
      "disabled": _vm.request !== null,
      "item-text": "name",
      "label": "Источник",
      "clearable": true
    },
    model: {
      value: _vm.form.source,
      callback: function ($$v) {
        _vm.$set(_vm.form, "source", $$v);
      },
      expression: "form.source"
    }
  }), _vm.form.errors.has('source') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('source')) + " ")]) : _vm._e()], 1) : _vm._e(), _vm.$helper.permission.canChangeSubdivision(_vm.user) ? _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "label": "Подразделение",
      "items": _vm.subdivisions,
      "item-value": "id",
      "item-text": "name",
      "clearable": true
    },
    model: {
      value: _vm.form.subdivision,
      callback: function ($$v) {
        _vm.$set(_vm.form, "subdivision", $$v);
      },
      expression: "form.subdivision"
    }
  }), _vm.form.errors.has('subdivision') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('subdivision')) + " ")]) : _vm._e()], 1) : _vm._e(), _vm.$helper.permission.canAssignRequest(_vm.user) ? _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "label": "Оператор",
      "items": _vm.operators,
      "item-value": "id",
      "item-text": "fullName",
      "clearable": true
    },
    model: {
      value: _vm.form.operator,
      callback: function ($$v) {
        _vm.$set(_vm.form, "operator", $$v);
      },
      expression: "form.operator"
    }
  }), _vm.form.errors.has('operator') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('operator')) + " ")]) : _vm._e()], 1) : _vm._e()], 1), _vm.request !== null ? _c('v-row', [_vm.$helper.permission.canSeeCreatedAtOfRequest(_vm.user) ? _c('v-col', [_c('v-text-field', {
    attrs: {
      "value": _vm.form.createdAt,
      "disabled": "disabled",
      "label": "Дата создания"
    }
  })], 1) : _vm._e(), _c('v-col', [_c('v-text-field', {
    attrs: {
      "value": _vm.form.assignedAt,
      "disabled": "disabled",
      "label": "Дата привязки"
    }
  })], 1), _vm.$helper.permission.canAssignCounterpart(_vm.user) ? _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "label": "Контрагент",
      "items": _vm.counterparts,
      "item-value": "id",
      "item-text": "fullName",
      "clearable": true
    },
    model: {
      value: _vm.form.counterpart,
      callback: function ($$v) {
        _vm.$set(_vm.form, "counterpart", $$v);
      },
      expression: "form.counterpart"
    }
  }), _vm.form.errors.has('counterpart') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('counterpart')) + " ")]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "Имя"
    },
    model: {
      value: _vm.form.userName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userName", $$v);
      },
      expression: "form.userName"
    }
  }), _vm.form.errors.has('userName') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('userName')) + " ")]) : _vm._e()], 1), _c('v-col', [_c('v-row', {
    staticStyle: {
      "margin-top": "-12px",
      "margin-bottom": "-12px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '+7 (###) ###-##-## #',
      expression: "'+7 (###) ###-##-## #'"
    }],
    attrs: {
      "data-test": "field-phone",
      "label": "Телефон"
    },
    model: {
      value: _vm.form.userPhone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userPhone", $$v);
      },
      expression: "form.userPhone"
    }
  }), _vm.form.errors.has('userPhone') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('userPhone')) + " ")]) : _vm._e()], 1), _vm.form.userPhone ? _c('v-col', {
    staticClass: "col-auto"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": `tel:${_vm.form.userPhone}`
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "color": "green"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-phone")])], 1)], 1)]) : _vm._e()], 1)], 1), _c('v-col', [_c('v-row', {
    staticStyle: {
      "margin-top": "-12px",
      "margin-bottom": "-12px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '+7 (###) ###-##-## #',
      expression: "'+7 (###) ###-##-## #'"
    }],
    attrs: {
      "label": "Доп. телефон"
    },
    model: {
      value: _vm.form.additionalUserPhone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "additionalUserPhone", $$v);
      },
      expression: "form.additionalUserPhone"
    }
  }), _vm.form.errors.has('additionalUserPhone') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('additionalUserPhone')) + " ")]) : _vm._e()], 1), _vm.form.additionalUserPhone ? _c('v-col', {
    staticClass: "col-auto"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": `tel:${_vm.form.additionalUserPhone}`
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "color": "green"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-phone")])], 1)], 1)]) : _vm._e()], 1)], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "Email"
    },
    model: {
      value: _vm.form.userEmail,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userEmail", $$v);
      },
      expression: "form.userEmail"
    }
  }), _vm.form.errors.has('userEmail') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('userEmail')) + " ")]) : _vm._e()], 1), _vm.form.userIp ? _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "Ip",
      "disabled": ""
    },
    model: {
      value: _vm.form.userIp,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userIp", $$v);
      },
      expression: "form.userIp"
    }
  }), _vm.form.errors.has('userIp') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('userIp')) + " ")]) : _vm._e()], 1) : _vm._e()], 1), _c('v-row', [_c('v-col', [_c('v-autocomplete', {
    attrs: {
      "items": _vm.areas,
      "item-value": "id",
      "item-text": "name",
      "label": "Область права",
      "required": "",
      "clearable": false
    },
    model: {
      value: _vm.form.area,
      callback: function ($$v) {
        _vm.$set(_vm.form, "area", $$v);
      },
      expression: "form.area"
    }
  }), _vm.form.errors.has('area') || _vm.form.errors.has('areaNotEmptyWhenOperatorNotNull') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s((_vm$form$errors$get = _vm.form.errors.get('area')) !== null && _vm$form$errors$get !== void 0 ? _vm$form$errors$get : _vm.form.errors.get('areaNotEmptyWhenOperatorNotNull')) + " ")]) : _vm._e()], 1), _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "items": _vm.cities,
      "item-value": "id",
      "item-text": "name",
      "label": "Город",
      "clearable": true
    },
    model: {
      value: _vm.form.city,
      callback: function ($$v) {
        _vm.$set(_vm.form, "city", $$v);
      },
      expression: "form.city"
    }
  }), _vm.form.errors.has('city') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('city')) + " ")]) : _vm._e()], 1)], 1), _c('v-row', [_c('v-col', [_c('v-textarea', {
    attrs: {
      "data-test": "field-problem",
      "auto-grow": "",
      "label": "Проблема"
    },
    model: {
      value: _vm.form.problem,
      callback: function ($$v) {
        _vm.$set(_vm.form, "problem", $$v);
      },
      expression: "form.problem"
    }
  }), _vm.form.errors.has('problem') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('problem')) + " ")]) : _vm._e()], 1)], 1), _vm.score && _vm.score.problemDescription ? _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-textarea', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "auto-grow": "",
      "readonly": "",
      "filled": "",
      "rows": "1",
      "value": _vm.score.problemDescription,
      "label": "Описание проблемы от ИИ",
      "hint": "Формируется и обновляется автоматически по мере накопления данных о клиенте",
      "persistent-hint": ""
    }
  })], 1)], 1) : _vm._e(), _vm.form.wishes && _vm.form.wishes.length ? _c('v-row', {
    staticClass: "pb-3"
  }, [_c('v-col', [_c('div', {
    staticClass: "text-caption grey--text mb-2"
  }, [_vm._v("Детали обращения")]), _c('v-chip-group', {
    attrs: {
      "column": ""
    }
  }, _vm._l(_vm.form.wishes, function (wish, i) {
    return _c('v-chip', {
      key: i,
      attrs: {
        "color": "orange lighten-4",
        "text-color": "orange darken-4",
        "small": "",
        "label": ""
      }
    }, [_vm._v(" " + _vm._s(wish) + " ")]);
  }), 1)], 1)], 1) : _vm._e(), _vm.form.budget ? _c('v-row', {
    staticClass: "pb-3"
  }, [_c('v-col', [_c('div', {
    staticClass: "text-caption grey--text mb-2"
  }, [_vm._v("Ориентировочный бюджет")]), _c('v-chip', {
    attrs: {
      "color": "green lighten-4",
      "text-color": "green darken-4",
      "small": "",
      "label": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.form.budget) + " ")])], 1)], 1) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "3"
    }
  })], 1), _vm.form.errors.any() ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" Исправьте ошибки ")]) : _vm._e(), _vm.form.errors.has('error') ? _c('v-alert', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "icon": false
    }
  }, [_vm._v(" " + _vm._s(_vm.form.errors.get('error')) + " ")]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.form.busy,
      expression: "!form.busy"
    }]
  }, [_c('v-btn', {
    attrs: {
      "data-test": "form-save-stay",
      "large": "",
      "color": "green"
    },
    on: {
      "click": function ($event) {
        _vm.request ? _vm.update(false) : _vm.save(false);
      }
    }
  }, [_vm._v(" Сохранить ")]), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "data-test": "form-save",
      "large": "",
      "color": "green"
    },
    on: {
      "click": function ($event) {
        _vm.request ? _vm.update(true) : _vm.save(false);
      }
    }
  }, [_vm._v(" Сохранить и закрыть ")])], 1), _c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.busy,
      expression: "form.busy"
    }],
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)])], 1) : _vm._e(), _vm.request ? _c('ScoreDetailDialog', {
    attrs: {
      "dialog-visible": _vm.dialog.scoreDetail.modal,
      "request-id": _vm.request.id
    },
    on: {
      "close": function ($event) {
        _vm.dialog.scoreDetail.modal = false;
      },
      "recomputed": function ($event) {
        return _vm.fetchScore();
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "my-10"
  }, [(_vm$request = _vm.request) !== null && _vm$request !== void 0 && _vm$request.userPhone ? _c('RequestDoubles', {
    attrs: {
      "title": `Заявки клиента с номером: ${_vm.request.userPhone}`,
      "filter": {
        cleanPhone: _vm.request.cleanPhone,
        isDoubles: true,
        showForOperatorsWithoutPermissions: true
      },
      "exclude": [_vm.request.id]
    }
  }) : _vm._e(), (_vm$request2 = _vm.request) !== null && _vm$request2 !== void 0 && _vm$request2.additionalUserPhone ? _c('RequestDoubles', {
    attrs: {
      "title": `Заявки клиента с номером: ${_vm.request.additionalUserPhone}`,
      "filter": {
        cleanPhone: _vm.request.cleanAdditionalUserPhone,
        showForOperatorsWithoutPermissions: true
      },
      "exclude": [_vm.request.id]
    }
  }) : _vm._e()], 1), _vm.request && _vm.$helper.permission.canSeeCalls(_vm.user) ? _c('CallsGrid', {
    attrs: {
      "title": `Вызовы для номера: ${_vm.userPhones}`,
      "filter": {
        clientPhones: [_vm.request.cleanPhone, _vm.request.cleanAdditionalUserPhone]
      }
    }
  }) : _vm._e(), _vm.request ? _c('RequestComments', {
    attrs: {
      "id": _vm.request.id
    }
  }) : _vm._e(), _vm.request && _vm.$helper.permission.canSeeRequestAnswers(_vm.user) ? _c('RequestAnswers', {
    attrs: {
      "request": _vm.request,
      "areas": _vm.areas
    }
  }) : _vm._e(), _vm.$helper.isUserRole(_vm.user, 'ADMIN') && (_vm.attributionRows.length || _vm.quizRows.length) ? _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "text-subtitle-1"
  }, [_vm._v("Откуда заявка")]), _c('v-card-text', [_vm.attributionRows.length ? _c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', _vm._l(_vm.attributionRows, function (row) {
    return _c('tr', {
      key: row.label
    }, [_c('td', {
      staticClass: "grey--text",
      staticStyle: {
        "width": "180px"
      }
    }, [_vm._v(_vm._s(row.label))]), _c('td', {
      staticStyle: {
        "word-break": "break-all"
      }
    }, [_vm._v(_vm._s(row.value))])]);
  }), 0)]) : _vm._e(), _vm.quizRows.length ? _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "text-caption grey--text mb-1"
  }, [_vm._v("Ответы квиза")]), _vm._l(_vm.quizRows, function (row) {
    return _c('v-chip', {
      key: row.label,
      staticClass: "mr-2 mb-2",
      attrs: {
        "small": "",
        "label": ""
      }
    }, [_vm._v(" " + _vm._s(row.label) + ": " + _vm._s(row.value) + " ")]);
  })], 2) : _vm._e()], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }